export default {
	USER_IS_UNSUBSCRIBED:
		'Unfortunately, you can not reply to the conversation - The lead has unsubscribed from the conversation',
	CONVERSATION_NOT_FOUND: 'Conversation not found',
}
